export default "__VITE_ASSET__XXl4tqOi__"